import { Checkbox, Form } from 'antd';

export const AgreementFormItem = () => {
  return (
    <Form.Item
      name="agreement"
      className="agreement_form_item"
      valuePropName="checked"
      rules={[
        {
          validator(_, value) {
            if (value === true) return Promise.resolve(undefined);
            return Promise.reject('未勾选用户协议和隐私条款');
          },
        },
      ]}
    >
      <Checkbox>
        <span className="checkText">
          已阅读并同意
          <a rel="noreferrer" href="https://www.aminer.cn/protocol" target={'_blank'}>
            《用户协议》
          </a>
          和
          <a rel="noreferrer" href="https://www.aminer.cn/policy" target={'_blank'}>
            《隐私政策》
          </a>
        </span>
      </Checkbox>
    </Form.Item>
  );
};
